import { render } from "./DefaultHeader.vue?vue&type=template&id=efd01ff6&scoped=true&ts=true"
import script from "./DefaultHeader.vue?vue&type=script&lang=ts"
export * from "./DefaultHeader.vue?vue&type=script&lang=ts"

import "./DefaultHeader.vue?vue&type=style&index=0&id=efd01ff6&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-efd01ff6"]])

export default __exports__